import React from 'react';
import { useAuth } from '@contexts/AuthContext';
import Navbar from './Navbar';
import Footer from './Footer';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const { isAuthenticated, user } = useAuth();

  const handleLoginClick = () => {
    // Dispatch custom event to open global login modal
    window.dispatchEvent(new CustomEvent('openLoginModal'));
  };

  const handleProfileClick = () => {
    // Dispatch custom event to open profile modal
    window.dispatchEvent(new CustomEvent('openProfileModal'));
  };

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar
        isAuthenticated={isAuthenticated}
        user={user}
        onLoginClick={handleLoginClick}
        onProfileClick={handleProfileClick}
      />

      <main className="flex-1">
        {children}
      </main>

      <Footer />
    </div>
  );
};

export default Layout;
